const SALVAR_USUARIO_STATE = (state, payload) => {
  state.login = payload
}

const LOGANDO = (state, payload) => {
  state.logando = payload
}

const DELETAR_USUARIO_STATE = (state) => {
  state.login = {}
}

const LOADING = (state, payload) => {
  state.buscando = payload
}

const LISTAR_DADOS_AREA_RESPONSAVEL = (state, payload) => {
  state.itemsAreaResponsavel = payload
}

const LISTAR_DADOS_TIPO_OS = (state, payload) => {
  state.itemsTipoOs = payload
}

const LISTAR_DADOS_GRUPO_ATIVIDADE = (state, payload) => {
  state.itemsGrupoAtividade = payload
}


const LISTAR_DADOS_ATIVIDADE = (state, payload) => {
  state.itemsAtividade = payload
}

const LISTAR_JANELAS = (state, payload) => {  
  state.janelas = payload    
}

const LISTAR_FORMULARIOS = (state, payload) => {
  state.formularios = payload
}

const SALVAR_ORDENS_SERVICOS = (state, payload) => {
  state.itemsOrdemServico = payload
}

const LISTAR_TAREFAS_APOS_INCLUIR_OS = (state, payload) => {
  state.itemsTarefasDisponiveis = payload
}

export {
  SALVAR_USUARIO_STATE,
  DELETAR_USUARIO_STATE,
  LOGANDO,
  LOADING,
  LISTAR_DADOS_AREA_RESPONSAVEL,
  LISTAR_DADOS_TIPO_OS,
  LISTAR_DADOS_GRUPO_ATIVIDADE,
  LISTAR_DADOS_ATIVIDADE,
  LISTAR_JANELAS,
  LISTAR_FORMULARIOS,
  SALVAR_ORDENS_SERVICOS,
  LISTAR_TAREFAS_APOS_INCLUIR_OS
}